export default __webpack_public_path__ + "static/media/eram.327a0906.jpg";